/**
 * CreatedByCredit — the standing "Designed and developed by Smart Cloud Office"
 * attribution shown in every layout footer (app, portal, public).
 *
 * Smart Cloud Office (smartcloudoffice.com) built the platform; this is the
 * shared credit line so the wording and link stay identical everywhere.
 */

import { cn } from '@/lib/utils';

export default function CreatedByCredit({ className }: { className?: string }) {
  return (
    <p className={cn('text-center text-xs text-muted-foreground', className)}>
      Designed and developed by{' '}
      <a
        href="https://smartcloudoffice.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-primary underline-offset-2 hover:underline"
      >
        Smart Cloud Office
      </a>
    </p>
  );
}
